<script lang="ts">
  import { BUNDLED_FONTS, registerFont } from '../depth/fonts';
  import { t } from '../i18n/index.svelte';
  import { assets, studio } from '../state.svelte';
  import FileButton from './ui/FileButton.svelte';
  import Select from './ui/Select.svelte';
  import Slider from './ui/Slider.svelte';

  let { rotation = true }: { rotation?: boolean } = $props();
  let error = $state('');

  const fontOptions = $derived([
    ...BUNDLED_FONTS.map((f) => ({ value: f.id, label: f.name })),
    ...assets.customFonts.map((f) => ({ value: f.id, label: f.name })),
  ]);

  async function onFont(f: File) {
    error = '';
    try {
      const id = `custom:${f.name}`;
      registerFont(id, await f.arrayBuffer());
      if (!assets.customFonts.some((x) => x.id === id))
        assets.customFonts = [...assets.customFonts, { id, name: f.name }];
      studio.text.font = id;
    } catch (e) {
      error = t('error.font', { msg: String(e) });
    }
  }

  const deg = (v: number) => `${v}°`;
  const pct = (v: number) => `${Math.round(v * 100)}%`;
  const fix2 = (v: number) => v.toFixed(2);
</script>

<label class="field">
  <span>{t('text.content')}</span>
  <textarea rows="2" bind:value={studio.text.text} data-testid="text-input"></textarea>
</label>
<div class="row font">
  <Select label={t('text.font')} bind:value={studio.text.font} options={fontOptions} />
  <FileButton label={t('text.uploadFont')} accept=".ttf,.otf,.woff" onfile={onFont} />
</div>
<Slider label={t('text.fill')} bind:value={studio.text.fill} min={0.1} max={1} step={0.01} format={pct} />
<div class="grid2">
  <Slider label={t('text.extrude')} bind:value={studio.text.extrude} min={0.02} max={1.5} step={0.01} format={fix2} />
  <Slider label={t('text.bevel')} bind:value={studio.text.bevel} min={0} max={0.15} step={0.005} format={fix2} />
</div>
<div class="grid2">
  <Slider label={t('text.base')} bind:value={studio.text.base} min={0} max={1} step={0.01} format={fix2} />
  <Slider label={t('text.top')} bind:value={studio.text.top} min={0} max={1} step={0.01} format={fix2} />
</div>
{#if rotation}
  <div class="grid3">
    <Slider label={t('text.rotX')} bind:value={studio.text.rotX} min={-80} max={80} format={deg} />
    <Slider label={t('text.rotY')} bind:value={studio.text.rotY} min={-80} max={80} format={deg} />
    <Slider label={t('text.rotZ')} bind:value={studio.text.rotZ} min={-180} max={180} format={deg} />
  </div>
{/if}
{#if error}<p class="error small">{error}</p>{/if}

<style>
  .field {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 13px;
  }
  textarea {
    resize: vertical;
    font-size: 16px;
  }
  .font {
    align-items: end;
  }
  .font :global(.field) {
    flex: 1;
  }
  .font :global(.drop) {
    padding: 6px 8px;
    white-space: nowrap;
  }
  .grid3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
  .small {
    font-size: 12px;
    margin: 0;
  }
</style>
